import {
  ActiveLookup,
  LINKED_IN_TYPE_LOOKUP,
  LinkedInType,
  LookupKeys,
  Messages,
  Patterns,
  Social,
  SocialKeys,
  socialMediaUrlMap,
  YOUTUBE_TYPE_LOOKUP,
  YoutubeType,
} from '@ag-common-lib/public-api';
import { Component, HostBinding, Input } from '@angular/core';
import { SocialFormService } from './social-form.service';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { validateStringByPattern, validateUrlWithOrWithoutProtocol } from 'ag-common-svc/lib/utils/validation';
import { PasteEvent } from 'devextreme/ui/text_box';

@Component({
  selector: 'ag-shr-social-form',
  templateUrl: './social-form.component.html',
  styleUrls: ['./social-form.component.scss'],
  providers: [SocialFormService],
})
export class SocialFormComponent {
  @HostBinding('class') protected className = 'social-form';

  @Input() validationGroup: string;
  @Input() socialMediaLookup: ActiveLookup[] = [];
  @Input() socialTypesLookup: ActiveLookup[] = [];
  @Input() includeSocialType = true;

  @Input()
  set social(value: Social) {
    this.formData = this.socialFormService.getFormData(value);
  }

  formData: Partial<Social>;
  protected readonly SocialKeys = SocialKeys;
  protected readonly LookupKeys = LookupKeys;
  protected readonly BaseModelKeys = BaseModelKeys;
  protected readonly Messages = Messages;
  protected readonly LinkedInType = LinkedInType;
  protected readonly YoutubeType = YoutubeType;
  protected readonly LINKED_IN_TYPE_LOOKUP = LINKED_IN_TYPE_LOOKUP;
  protected readonly YOUTUBE_TYPE_LOOKUP = YOUTUBE_TYPE_LOOKUP;
  protected readonly socialMediaUrlMap = socialMediaUrlMap;

  constructor(private socialFormService: SocialFormService) {}

  onCancelEdit = this.socialFormService.onCancelEdit;

  validateUrlWithOrWithoutProtocol = e =>
    validateUrlWithOrWithoutProtocol(e?.value, Patterns.URL_PATTERN_WITH_OR_WITHOUT_ONLY_ONE_PROTOCOL);

  validateUserName = e => validateStringByPattern(Patterns.SOCIAL_USERNAME_REG_EXP, e?.value);

  protected get isTypeDependentForm(): boolean {
    return this.includeSocialType;
  }

  onPasteHandler(e: PasteEvent): void {
    e.event.preventDefault();
    const clipboardEvent = e?.event['originalEvent'] as ClipboardEvent | undefined;
    const pastedText = clipboardEvent?.clipboardData?.getData('text') ?? '';
    const accountId = this.socialFormService.extractAccountIdFromPastedText(
      pastedText,
      this.formData?.[SocialKeys.socialMedia],
    );

    e.component?.option('value', accountId);
  }
}
